import { dominosStore } from '../../main';
import { abort, goFish } from '../../shared/global/api';
import { getConfig } from '../AppMain/config';

/**
 * Get summary response from API or store if comming from cart directly.
 */
export const getSummary = async (): Promise<SummaryResponse> => {
    const resp = dominosStore.cartStore.summaryResponse;
    if (resp) {
        dominosStore.cartStore.summaryResponse = null;
        return resp;
    } else {
        return goFish({ api: 'getsummary' });
    }
};

export const abortGetSummary = () => {
    abort('getsummary');
};

/**
 * Parse pizza from cart into description string.
 * @param pizza
 */
export const getPizzaOptionsAsString = (pizza: CartPizzaResponse) => {
    const dip = pizza.Options.filter((p: CartProductResponse) => p.isDip && p.Count > 0)
        .map(p => p.Name)
        .join();
    const added = pizza.Options.filter(
        (p: CartProductResponse) => !p.isDip && p.Count > p.DefaultCount
    )
        .map(p => (p.Count - p.DefaultCount) > 1 ? p.Name + ' x ' + (p.Count - p.DefaultCount) : p.Name )
        .join(', +');
    const removed = pizza.Options.filter(
        (p: CartProductResponse) => !p.isDip && p.Count < p.DefaultCount
    )
        .map(p => p.Name)
        .join(', -');

    let details = `${pizza.SizeName}, ${pizza.FlavorName}, ${dip}`;
    if (added) {
        details += `, +${added}`;
    }
    if (removed) {
        details += `, -${removed}`;
    }
    return details;
};

export const checkoutManage = (dataToSend: SummupFormSendParams): Promise<CheckoutResponse> => {
    return goFish({
        api: 'checkout',
        data: dataToSend
    });
};

export const w8tickTime = () => {
    const { ecommerce } = getConfig();
    return (ecommerce.w8tickTimeSeconds || 5) * 1000;
};

export const saveW8 = () => {
    localStorage.setItem('w8', Date.now().toString());
};

export const clearW8 = () => {
    localStorage.removeItem('w8');
};

export const checkW8 = () => {
    const w8 = localStorage.getItem('w8');
    if (w8) {
        const { ecommerce } = getConfig();
        const d = new Date(parseInt(w8));
        d.setHours(d.getHours(), d.getMinutes() + (ecommerce.w8TimeMinute || 5));
        const now = new Date();
        if (d > now) {
            return true;
        }
    }

    return false;
};

export const w8Manage = (): Promise<CheckoutResponse> => {
    return goFish({
        api: 'checkoutstatus'
    });
};
